import dynamic from "next/dynamic";
const App = dynamic(() => import("../components/App"));
import React, { useState } from "react";
import Head from "next/head";
import Link from "next/link";
import { useRouter } from "next/router";
import axios from "axios";
import {
  Breadcrumb,
  Spin,
  Typography,
  Row,
  Col,
  Image,
  Space,
  Form,
  Input,
  Button,
  notification,
} from "antd";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Api } from "../networks/Api";

const { Title, Text } = Typography;

export async function getServerSideProps(ctx) {
  return {
    props: {
      ...(await serverSideTranslations(ctx?.locale, ["common"])),
      token: ctx?.req?.cookies?.token || null,
    },
  };
}

const style_opening_hour = {
  width: "100%",
  maxWidth: "200px",
  display: "flex",
  justifyContent: "space-between",
};

const Home = ({
  token,
  categoryMenu,
  hasSale,
  hasLive,
  dataSeo,
  dataReferrer,
}) => {
  const { t } = useTranslation("common");
  const [contactFrom] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const router = useRouter();
  const { locale } = router;
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const openNotificationError = (msg) => {
    notification.open({
      message: "Notice",
      description: msg,
      placement: "top",
    });
  };

  const onFinish = async (values) => {
    if (!phone && !email) {
      notification.open({
        message: "Please fill out this form ",
        description: "email and phone number is required",
        placement: "top",
      });
      return;
    }

    setLoading(true);
    const url = `${Api.addContact}`;
    const postData = {
      name: values.name,
      email: values.email,
      phone: values.phone,
      message: values.message,
      language: locale,
    };

    try {
      const response = await axios.post(url, postData, Api.Header());
      if (response.status == 200) {
        contactFrom.setFieldsValue({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
        setEmail("");
        setPhone("");
        notification.open({
          message: "Success",
          description: "Send message success.",
          placement: "top",
        });
        setLoading(false);
        return;
      } else {
        setLoading(false);
        openNotificationError(response.data.message);
        return;
      }
    } catch (e) {
      console.log("contact >> addContact error :", e);
      // AlertError('Something went wrong.')
      openNotificationError(e?.message);
      setLoading(false);
    }
  };

  const onFinishFailed = (e) => {
    console.log(e);
    message.error("Submit failed!");
  };

  const locationDatas = [
    // {
    //   province: `${t("bangkok")}`,
    //   locations: [
    //     {
    //       location: `${t("bangkok-siam-location")}`,
    //       map: "https://maps.app.goo.gl/gQJGrXgjy4d3ziP49",
    //     },
    //   ],
    // },
    {
      province: `${t("chiangmai")}`,
      locations: [
        {
          location: `${t("chiangmai-central-location")}`,
          map: "https://maps.app.goo.gl/Ure2aEqktuV71uQy6",
        },
        {
          location: `${t("chiangmai-maya-location")}`,
          map: "https://maps.app.goo.gl/W77CgKvmpe9Pv92B6",
        },
      ],
    },
    {
      province: `${t("udonthani")}`,
      locations: [
        {
          location: `${t("udonthani-location")}`,
          map: "https://maps.app.goo.gl/CfEGzMF72BBN1R2m7",
        },
      ],
    },
    {
      province: `${t("nonthaburi")}`,
      locations: [
        {
          location: `${t("westgate-location")}`,
          map: "https://maps.app.goo.gl/bVWALUzEJn5x6PcV9",
        },
      ],
    },
    {
      province: `${t("phitsanulok")}`,
      locations: [
        {
          location: `${t("phitsanulok-central-location")}`,
          map: "https://maps.app.goo.gl/JJH5Fkd1vRBus8Qd9",
        },
      ],
    },
  ];

  return (
    <App
      token={token}
      categoryMenu={categoryMenu}
      hasSale={hasSale}
      hasLive={hasLive}
      dataSeo={dataSeo}
      dataReferrer={dataReferrer}
    >
      <Head>
        <title>Contact</title>
      </Head>
      <Spin spinning={loading}>
        <Row justify="center" style={{ marginBlock: 24 }}>
          <Col xs={22} sm={22} md={22} lg={22} xl={20}>
            <Breadcrumb
              style={{ marginBottm: 24 }}
              items={[
                {
                  key: "home",
                  title: (
                    <Link href={`/${queryParam ? `?${queryParam}` : ``}`}>
                      {t("home")}
                    </Link>
                  ),
                },
                {
                  key: "contact",
                  title: `${t("contact")}`,
                },
              ]}
            />
            <Row gutter={[12, 24]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Space direction="vertical" style={{ marginTop: 24 }}>
                  <p className="h4">Here to Help</p>
                  <Text>{t("help-text")}</Text>

                  {locationDatas?.map((datas) => {
                    return (
                      <>
                        <Text className="h5 mb-0 mt-5">{datas?.province}</Text>

                        {datas?.locations?.map((locations, index) => {
                          return (
                            <a
                              key={`locations-${index}`}
                              href={locations?.map}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Space
                                direction="horizontal"
                                align="center"
                                className="mt-0"
                              >
                                <Image
                                  width={14}
                                  preview={false}
                                  src="/static/images/ic_location.png"
                                  alt="location"
                                />
                                <Text>{locations?.location}</Text>
                              </Space>
                            </a>
                          );
                        })}
                      </>
                    );
                  })}

                  <Space
                    style={{ marginTop: 24 }}
                    direction="horizontal"
                    align="center"
                  >
                    <Image
                      width={14}
                      preview={false}
                      src="/static/images/ic_mail.png"
                      alt="mail"
                    />
                    <Text>Email: info@luxury29.io</Text>
                  </Space>
                  <p className="h4" style={{ marginTop: 24 }}>
                    Opening Hours:
                  </p>
                  <Space style={style_opening_hour}>
                    <Text>Sunday</Text>
                    <Text>11AM - 10PM</Text>
                  </Space>
                  <Space style={style_opening_hour}>
                    <Text>Monday</Text>
                    <Text>11AM - 10PM</Text>
                  </Space>
                  <Space style={style_opening_hour}>
                    <Text>Tuesday</Text>
                    <Text>11AM - 10PM</Text>
                  </Space>

                  <Space style={style_opening_hour}>
                    <Text>Wednesday</Text>
                    <Text>11AM - 10PM</Text>
                  </Space>

                  <Space style={style_opening_hour}>
                    <Text>Thursday</Text>
                    <Text>11AM - 10PM</Text>
                  </Space>

                  <Space style={style_opening_hour}>
                    <Text>Friday</Text>
                    <Text>11AM - 10PM</Text>
                  </Space>

                  <Space style={style_opening_hour}>
                    <Text>Saturday</Text>
                    <Text>11AM - 10PM</Text>
                  </Space>
                </Space>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Space direction="vertical">
                  <p className="h4">Drop Us A Line</p>
                  <Text>{t("qa-text")}</Text>
                  <Form
                    form={contactFrom}
                    name="contact"
                    layout="vertical"
                    onFinish={onFinish}
                    AddressFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Row gutter={[16]}>
                      <Col span={24}>
                        <Form.Item
                          name="name"
                          className="label-require"
                          label="NAME (required)*"
                          rules={[{ required: true }, { type: "string" }]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder="Enter your name"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="email"
                          label={`EMAIL (required)*`}
                          rules={[{ type: "email" }]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder="Please enter either email or phone number."
                            onChange={(e) => {
                              setEmail(e?.target?.value);
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="phone"
                          label={`PHONE (required)*`}
                          rules={[
                            {
                              type: "string",
                              min: 10,
                              max: 10,
                            },
                          ]}
                        >
                          <Input
                            className="input-checkout"
                            size="large"
                            placeholder="Please enter either email or phone number."
                            onChange={(e) => {
                              setPhone(e?.target?.value);
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          className="label-require"
                          name="message"
                          label="YOUR MESSAGE (required)*"
                          rules={[{ required: true }, { type: "string" }]}
                        >
                          <Input.TextArea
                            className="input-checkout"
                            size="large"
                            placeholder="Enter your message"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item>
                          <Space direction="vertical" style={{ width: "100%" }}>
                            <Button
                              className="btn-login"
                              size="large"
                              type="primary"
                              htmlType="submit"
                              block
                            >
                              SEND MESSAGE
                            </Button>
                          </Space>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </App>
  );
};

export default Home;
